import * as React from 'react';
import { connect } from 'react-redux';
import { fetchOrdenes, setFiltroOrdenes } from '../../../actions/ordenesActions';
import { fetchExportarOrdenesApi } from '../../../api/axios';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import FiltroOrdenes from '../../Ordenes/FiltroOrdenes';
import { toast } from 'react-toastify';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import MiniSpinner from "../../General/MiniSpinner";
import BigSpinner from "../../General/BigSpinner";
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';
import PropTypes from "prop-types";
const fechaFiltro = filtroMedioMes();

class ExportarOrdenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            datosExcelFormateados: null,
            hideSpinner: true,
            request: {
                idSeller: this.props.idSeller,
                cantidadPagina: 10,
                numeroPagina: 1,
                idOrden: "",
                documento: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                entidadOrdenamiento: 1
            },
            cantidadOrdenes: 0,
            archivoExcel: "",
            loadingExport: false,
        };
        const { isCategory, isAdminMod } = this.props.userType;
        this.allowSearchBySeller = isCategory || isAdminMod;
    }

    componentDidMount() {
        this.props.ordenes.cantidadTotal = 0;

        let estadoInicioFiltraPor_Moderador = { ...this.state.request, idSeller: "" }
        let request = this.props.filtroOrdenes;

        if (this.props.emptyFiltro.ordenes) {
            if (this.allowSearchBySeller) {
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador });
            } else {
                this.props.setFiltroOrdenes(this.state.request);
            }
        } else {
            request.numeroPagina = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
        }

        if (this.allowSearchBySeller) {
            this.props.fetchSellersFilter({
                Descripcion: "",
                Page: 1,
                PageSize: 100
            });
        }
    }

    updateRequest = (request) => {
        this.setState({
            hideSpinner: false, cantidadOrdenes: 0 });

        if (!this.allowSearchBySeller && typeof request.idSeller === 'undefined') {
            request.idSeller = this.props.idSeller;
        }

        this.setState({
            request,
            currentPage: request.numeroPagina,
            datosExcelFormateados: null
        });

        this.props.setFiltroOrdenes(request);

        let filtroOrdenes = request;
        let paramsOrdenes = {
            idSeller: request.idSeller === "" ? null : Number.parseInt(request.idSeller),
            fechaDesde: filtroOrdenes.fechaDesde,
            fechaHasta: filtroOrdenes.fechaHasta,
            idEstado: filtroOrdenes.idEstado === "" || Number.isNaN(Number.parseInt(filtroOrdenes.idEstado)) ? null : Number.parseInt(filtroOrdenes.idEstado),
            idOrden: filtroOrdenes.idOrden === "" || Number.isNaN(Number.parseInt(filtroOrdenes.idOrden)) ? null : Number.parseInt(filtroOrdenes.idOrden),
            documento: filtroOrdenes.documento === "" || Number.isNaN(Number.parseInt(filtroOrdenes.documento)) ? null : Number.parseInt(filtroOrdenes.documento),
            apellido: filtroOrdenes.apellido === "" ? null : filtroOrdenes.apellido,
            skuMarket: filtroOrdenes.skuMarket === "" ? null : filtroOrdenes.skuMarket,
            TipoOrden: filtroOrdenes.TipoOrden === "" || Number.isNaN(Number.parseInt(filtroOrdenes.TipoOrden)) ? null : Number.parseInt(filtroOrdenes.TipoOrden),
        }

        this.requestParaExportar(paramsOrdenes);
    }

    busquedaParaDescargarExcel = () => {
        this.setState({ datosExcelFormateados: null, hideSpinner: false });

        try {
            this.descargarArchivoExcel(this.state.archivoExcel, "Ordenes.xlsx");

            // Espera breve antes de ocultar el spinner (opcional, da feedback visual)
            setTimeout(() => {
                this.setState({ hideSpinner: true });
            }, 5000);
        } catch {
            toast.error('No se pudo descargar el excel');
            return;
        }
    }

    requestParaExportar = async (request) => {
        this.setState({ loadingExport: true });

        let req = null;
        try {
            req = await fetchExportarOrdenesApi(request);
            this.setState({
                cantidadOrdenes: req.cantidadOrdenes || 0,
                archivoExcel: req.excel,
                hideSpinner: true,
            })

        } catch (err) {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error('No se pudo obtener la información');

            this.setState({ hideSpinner: true });
            return;
        } finally {
            this.setState({ loadingExport: false });
        };
    }

    descargarArchivoExcel = (base64Data, nombreArchivo) => {
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    ordenarExcel = (ordenesResponse) => {
        let ordenes = ordenesResponse.ordenes
        let listaOrdenes = [];

        for (let orden of ordenes) {
            let fechaOrden = ""
            if (orden.fecha !== null) {
                let fechaSplit = orden.fecha.slice(0, 10).split('-');
                fechaOrden = `${fechaSplit[2]}-${fechaSplit[1]}-${fechaSplit[0]}`;
            }

            let ordenMultipleProductos = orden.productos?.length > 1;

            orden.productos?.forEach((p) => {
                let montoVenta = this.changeMonto(orden.montoVenta);
                let precioUnitario = this.changeMonto(p.precioUnitario);

                let datoOrden = {
                    fecha: fechaOrden,
                    idOrden: orden.idOrden,
                    cuitSeller: orden.seller?.cuit ?? "",
                    nombreSeller: orden.seller?.descripcion ?? "",
                    dniCliente: orden.cliente?.documento ?? "",
                    nombreApellidoCliente: (orden.cliente?.nombre ?? "") + " " + (orden.cliente?.apellido ?? ""),
                    domicilioCliente: orden.cliente?.domicilio ?? "",
                    codigoPostalCliente: orden.cliente?.codigoPostal ?? "",
                    localidadCliente: (orden.cliente?.localidad ?? "") + " " + orden.cliente?.provincia,
                    estado: orden.estado[0]?.descripcion ?? "",
                    montoVenta: ordenMultipleProductos ? "" : montoVenta,
                    tipoPublicacion: orden.tipoPublicacion?.tipo ?? "",
                    comision: ordenMultipleProductos ? "" : orden.montoComision,
                    nroPlan: orden.pago?.cupones?.length > 0 ? orden.pago.cupones[0].nroPlan : "",
                    binTarjeta: orden.pago?.cupones?.length > 0 ? orden.pago.cupones[0].primerosSeisDigitos : "",
                    nroCupon: orden.pago?.cupones?.length > 0 ? orden.pago.cupones[0].nroCupon : "",
                    idTransaccion: orden.pago?.cupones?.length > 0 ? orden.pago.cupones[0].idTransaccion : "",
                    adquiriente: orden.pago?.cupones?.length > 0 ? orden.pago.cupones[0].adquiriente : "",
                    nroPlan2: orden.pago?.cupones?.length > 1 ? orden.pago.cupones[1].nroPlan : "",
                    binTarjeta2: orden.pago?.cupones?.length > 1 ? orden.pago.cupones[1].primerosSeisDigitos : "",
                    nroCupon2: orden.pago?.cupones?.length > 1 ? orden.pago.cupones[1].NroCupon : "",
                    idTransaccion2: orden.pago?.cupones?.length > 1 ? orden.pago.cupones[1].idTransaccion : "",
                    adquiriente2: orden.pago?.cupones?.length > 1 ? orden.pago.cupones[1].adquiriente : "",
                    subfamilia: p?.subfamilia?.descripcion ?? "",
                    producto: p?.titulo ?? "",
                    cantidad: p?.cantidad,
                    precioUnitario: precioUnitario,
                    skuSeller: p?.sellerSku ?? "",
                    skuMarket: p?.skuMarket ?? "",
                    idVendedorBoca: orden.idVendedorBoca,
                    origenOrdenWeb: this.origenOrdenExcel(orden.plataforma.codigo),
                    detalleEnvio: orden.montoGastoEnvio == 0 ? "Con Envío Gratis" : "Sin Envío",
                    domicilioEntrega: orden.entrega?.entregaDomicilio?.domicilio || "",
                    cpEntrega: orden.entrega?.entregaDomicilio?.codigoPostal || "",
                    tipoEntrega: orden.entrega?.entregaSucursalCorreo?.sucursal != null ? "Retira en " + orden.entrega.entregaSucursalCorreo.sucursal : "Envío a domicilio",
                    sucursalSeleccionada: orden.entrega?.entregaSucursalCorreo?.idSucursal || "",
                    costoEnvio: orden.montoGastoEnvio
                };

                listaOrdenes.push(datoOrden);
            })
        }

        this.setState({
            datosExcelFormateados: listaOrdenes,
            hideSpinner: true
        })

        if (this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2) {
            document.getElementById('btnDescargaExcel').click();
        } else {
            document.getElementById('btnDescargaExcelSeller').click();
        }
    }

    changeMonto = (num) => {
        if (typeof num === "string") {
            num = Number(num);
        }

        let formattedNumber = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(num);

        return formattedNumber;
    }

    origenOrdenExcel = (plataformaCodigo) => {
        switch (plataformaCodigo) {
            case 0:
                return 'Megatone'
            case 1:
                return 'Mega-Market'
            case 2:
                return 'Megatone-Express'
            default:
                return ""
        }
    }


    render() {
        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

        return (
            <section className="container" role="search">
                <div className="row page-titles">
                    <div className="col-12">
                        <div className="row justify-content-between align-items-center">

                            <div className="col-md-8 align-self-center">
                                <h4 className="text-themecolor color-rojo-megatone">Órdenes</h4>
                            </div>

                            <div className="col-12 col-md-auto">
                                <div className="row justify-content-center">
                                    <div className="col-auto button-group text-right d-block">
                                        {(this.state.hideSpinner || sizeArray != "[]") && <MiniSpinner />}
                                    </div>

                                    <div className="col-12 col-md-auto button-group text-right">
                                        <button
                                            type="button"
                                            onClick={this.busquedaParaDescargarExcel}
                                            className="btn btn-sm btn-green"
                                            disabled={
                                                this.props.loadingOrdenes ||
                                                this.state.cantidadOrdenes === 0 ||
                                                this.state.cantidadOrdenes === undefined
                                            }
                                        >
                                            Descargar {this.state.cantidadOrdenes} órdenes
                                        </button>
                                        <button 
                                            id="btnDescargaExcel" 
                                            type="button" 
                                            hidden={true}
                                            onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Ordenes', 'Ordenes')}
                                        />
                                        <button 
                                            id="btnDescargaExcelSeller" 
                                            type="button" 
                                            hidden={true}
                                            onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Ordenes', 'Ordenes')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FiltroOrdenes
                    filtro={this.props.filtroOrdenes}
                    updateRequest={this.updateRequest}
                    allowSearchBySeller={this.allowSearchBySeller}
                    onClearCantidad={() => this.setState({ cantidadOrdenes: 0 })}
                    loadingExport={this.state.loadingExport}
                />

                {this.props.loadingOrdenes && <BigSpinner />}
            </section>
        );
    }
}
ExportarOrdenes.propTypes = {
    // Redux props
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    userType: PropTypes.shape({
        isCategory: PropTypes.bool,
        isAdminMod: PropTypes.bool,
    }),
    ordenes: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        ordenes: PropTypes.array,
        cantidadTotal: PropTypes.number,
    })]),
    filtroOrdenes: PropTypes.shape({
        numeroPagina: PropTypes.number,
        idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    emptyFiltro: PropTypes.shape({
        ordenes: PropTypes.bool,
    }),
    tipoUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    loadingOrdenes: PropTypes.bool,
    // Actions props
    setFiltroOrdenes: PropTypes.func,
    fetchSellersFilter: PropTypes.func,
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    tipoUsuario: state.general.tipoUsuario,
    idSeller: state.general.idSeller,
    ordenes: state.ordenes.ordenes,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    filtroOrdenes: state.ordenes.filtro,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, {
    fetchSellersFilter,
    limpiarFiltros,
    fetchOrdenes,
    setFiltroOrdenes
})(ExportarOrdenes);